/* eslint-disable react/no-unescaped-entities */
import LegalLayout, { Section, LEGAL } from "./LegalLayout";

export default function RefundPolicy() {
  return (
    <LegalLayout title="Refund Policy" testid="page-refund">
      <p>
        We want you to be satisfied with every purchase from {LEGAL.brand}. This Refund Policy explains when and how you may request a refund, and the limited exceptions that apply.
      </p>

      <Section id="window" title="1. 7-Day Money-Back Guarantee">
        <p>You may request a full refund within <span className="text-white font-semibold">7 days</span> of the original purchase date, for any reason, with no awkward questions. Refunds are issued to the original payment method and typically appear within 5–10 business days, depending on your bank and card network.</p>
      </Section>

      <Section id="how" title="2. How to Request a Refund">
        <p>To request a refund, email <a href={`mailto:${LEGAL.contactEmail}`} className="text-[#C9A66A]">{LEGAL.contactEmail}</a> from the email address used at checkout (or from any address — include your order token in the message). Please include:</p>
        <ul className="list-disc pr-5 space-y-1.5">
          <li>Order date and approximate amount.</li>
          <li>Product purchased.</li>
          <li>Order token (found in the confirmation page URL) if available.</li>
        </ul>
        <p>We aim to respond within 1 business day and process eligible refunds the same day.</p>
      </Section>

      <Section id="exceptions" title="3. Exceptions">
        <p>The following are not eligible for a refund:</p>
        <ul className="list-disc pr-5 space-y-1.5">
          <li>Requests made <span className="text-white font-semibold">after 7 days</span> from purchase.</li>
          <li>Purchases where the buyer has shared, redistributed, copied, or attempted to commercially exploit the product or its content (a material breach of the Terms of Service).</li>
          <li>Chargebacks initiated without first contacting us — we ask you to give us the chance to fix the issue first.</li>
          <li>Fraudulent or abusive refund patterns from the same buyer or device.</li>
        </ul>
      </Section>

      <Section id="failed" title="4. Failed or Duplicate Payments">
        <p>If you were charged but did not receive access to the product, or you were charged twice for the same order, email us immediately. These are not "refunds" — we treat them as billing errors and reverse the charge as a priority.</p>
      </Section>

      <Section id="processing" title="5. Processing Time">
        <p>Once approved, refunds are submitted to the payment processor on the same business day. The funds normally appear on your statement within:</p>
        <ul className="list-disc pr-5 space-y-1.5">
          <li>5–10 business days for international cards.</li>
          <li>3–5 business days for Gulf-issued cards.</li>
        </ul>
        <p>If a refund has not appeared after 10 business days, contact your bank first, then us — we will provide the processor's refund acknowledgement to forward to them.</p>
      </Section>

      <Section id="changes" title="6. Changes to This Policy">
        <p>We may update this Refund Policy from time to time. Changes are reflected by updating the "Last updated" date above. The version in force at the time of your purchase governs that order.</p>
      </Section>

      <Section id="contact" title="7. Contact">
        <p>All refund requests: <a href={`mailto:${LEGAL.contactEmail}`} className="text-[#C9A66A]">{LEGAL.contactEmail}</a>.</p>
      </Section>
    </LegalLayout>
  );
}
